import { useEffect, useRef } from "react"

import { isRowCancelEscape } from "./editable-row-cells.ts"

/**
 * Escape cancels an open edit row from the moment it opens, not only once
 * focus is inside it: a double-click to edit leaves focus on nothing. Keys
 * pressed inside the row are the row's own handler's (`rowCommitKeyDown`);
 * an Escape aimed at anything else (a search box, a popover, a dialog) is
 * left to that.
 */
export function useRowEscapeCancel(cancel: () => void, busy: boolean) {
  const cancelRef = useRef(cancel)
  cancelRef.current = cancel

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented || busy) return
      if (!isRowCancelEscape(event)) return
      const target = event.target
      if (target !== document.body && target !== document.documentElement)
        return
      const dialogOpen = Array.from(
        document.querySelectorAll<HTMLElement>(".ant-modal-wrap")
      ).some((wrap) => wrap.style.display !== "none")
      if (dialogOpen) return
      event.preventDefault()
      cancelRef.current()
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [busy])
}
